// extracted by mini-css-extract-plugin
module.exports = {"main":"Header_main__1LjXw","link":"Header_link__1uLZ-","alt_link":"Header_alt_link__2iV-1"};